import React, { useEffect, useState } from "react";
import {
  BomHeaderType,
  BomInstallationType,
  BomTotalType,
} from "../../../../commonTypes/billOfMaterial";
import { InfoViolet } from "../../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { changeToDecimel } from "../../../../utils/commonFunctions";

type AppProps = {
  total: {
    input: BomTotalType;
    output: BomTotalType;
  };
  setTotal: React.Dispatch<
    React.SetStateAction<{
      input: BomTotalType;
      output: BomTotalType;
      totalAdditionalCost?: number;
    }>
  >;
  bomInstallationData: BomInstallationType[];
  bomHeaderData: BomHeaderType;
  currencySign: string | undefined;
  setBomHeaderData: React.Dispatch<React.SetStateAction<BomHeaderType>>;
  setBomTempHeaderData: React.Dispatch<React.SetStateAction<BomHeaderType>>;
};

const BomCostOfInputGood = ({
  total,
  setTotal,
  bomInstallationData,
  setBomHeaderData,
  currencySign,
  setBomTempHeaderData,
  bomHeaderData,
}: AppProps) => {
  const [totalBomInstallation, setTotalBomInstallation] = useState<number>(0);
  useEffect(() => {
    let sum = 0;

    bomInstallationData?.map((item: BomInstallationType) => {
      sum += +item?.price;
    });
    setTotalBomInstallation(sum);
  }, [bomInstallationData]);

  useEffect(() => {
    setBomTempHeaderData((prev: BomHeaderType) => ({
      ...prev,
      rate: (
        (+(+total?.input?.amount + +totalBomInstallation) -
          +total?.output?.amount) /
        (+total?.input?.amount +
          +totalBomInstallation -
          +total?.output?.amount) /
        (!!bomHeaderData?.qty ? +bomHeaderData?.qty : 1)
      )?.toFixed(2),
      amount: (
        +total?.input?.amount +
        +totalBomInstallation -
        +total?.output?.amount
      )?.toString(),
    }));
    setTotal((data: any) => ({
      ...data,
      totalAdditionalCost: +totalBomInstallation,
    }));
  }, [total?.input?.amount, total?.output?.amount, totalBomInstallation]);

  return (
    <div className="bomInputGood">
      <div className="d-flex bomCostOfInput">
        <div className="costOfInputHeader">Cost of Input Items</div>

        <div className="costOfInputHeader" style={{ whiteSpace: "nowrap" }}>
          {currencySign} {changeToDecimel(total?.input?.amount)}
        </div>
      </div>

      <div className="d-flex bomCostOfInput">
        <div>Total Additional Cost</div>
        <div className="bomCOG">
          {currencySign} {changeToDecimel(totalBomInstallation)}
        </div>
      </div>

      <div className="d-flex bomCostOfInput">
        <div>
          Effective Cost
          <span className="ml-1">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-filter-invoice">
                  Cost of Input Items + Total Additional Cost
                </Tooltip>
              }
            >
              <span>
                <img src={InfoViolet} alt="info" />
              </span>
            </OverlayTrigger>
          </span>
        </div>
        <div className="bomCOG">
          {currencySign}{" "}
          {changeToDecimel(+total?.input?.amount + +totalBomInstallation)}
        </div>
      </div>

      <div className="d-flex bomCostOfInput">
        <div>
          Allocation to Primary Item
          <span className="ml-1">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-filter-invoice">
                  Effective Cost – Cost of Other Output Item
                </Tooltip>
              }
            >
              <span>
                <img src={InfoViolet} alt="info" />
              </span>
            </OverlayTrigger>
          </span>
        </div>
        <div className="bomCOG">
          {currencySign}{" "}
          {changeToDecimel(
            +total?.input?.amount +
              +totalBomInstallation -
              +total?.output?.amount
          )}
        </div>
      </div>

      <div className="d-flex bomCostOfInput">
        <div>
          Effective Rate of Primary Item
          <span className="ml-1">
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-filter-invoice">
                  Allocation to Primary Item/Quantity of primary item
                </Tooltip>
              }
            >
              <span>
                <img src={InfoViolet} alt="info" />
              </span>
            </OverlayTrigger>
          </span>
        </div>
        <div className="bomCOG">
          {currencySign}{" "}
          {changeToDecimel(
            (+(+total?.input?.amount + +totalBomInstallation) -
              +total?.output?.amount) /
              (!!bomHeaderData?.qty ? +bomHeaderData?.qty : 1)
              ? (+(+total?.input?.amount + +totalBomInstallation) -
                  +total?.output?.amount) /
                  (!!bomHeaderData?.qty ? +bomHeaderData?.qty : 1)
              : 0
          )}
          /Item
        </div>
      </div>
    </div>
  );
};

export default BomCostOfInputGood;
